export default __webpack_public_path__ + "static/bg-menu-a27550b8a78cd386fca5da8228dbede1.jpg";